"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./Chip.style"));

var ChipItem_1 = tslib_1.__importDefault(require("./ChipItem"));

var getValidChipIdList = function getValidChipIdList(rawChipIdList, allowMultiple) {
  var validIds = [];

  if (Array.isArray(rawChipIdList)) {
    validIds = allowMultiple ? rawChipIdList : rawChipIdList.slice(0, 1);
  } else {
    validIds = [rawChipIdList];
  }

  return validIds;
};

var ChipV2 = react_1.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      items = _ref.items,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? 'filled' : _ref$shape,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$activeChipId = _ref.activeChipId,
      activeChipId = _ref$activeChipId === void 0 ? '' : _ref$activeChipId,
      _ref$defaultChipId = _ref.defaultChipId,
      defaultChipId = _ref$defaultChipId === void 0 ? '' : _ref$defaultChipId,
      onChange = _ref.onChange,
      onActiveListChange = _ref.onActiveListChange;
  // 최초 active 상태 판정은 activeChipId + defaultChipId로 처리한다.
  // 이후에는 activeChipId 변화만 추적한다.
  var initialActiveState = react_1.useMemo(function () {
    var activeIds = getValidChipIdList(activeChipId, multiple);
    var defaultIds = getValidChipIdList(defaultChipId, multiple);
    var unionIds = defaultIds.reduce(function (acc, cur) {
      if (acc.includes(cur)) {
        return acc;
      }

      return [].concat(_toConsumableArray(acc), [cur]);
    }, _toConsumableArray(activeIds));
    return items.reduce(function (acc, cur) {
      return Object.assign(Object.assign({}, acc), _defineProperty({}, cur.id, unionIds.includes(cur.id)));
    }, {});
  }, [activeChipId, defaultChipId, items]);

  var _react_1$useState = react_1.useState(initialActiveState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      activeState = _react_1$useState2[0],
      setActiveState = _react_1$useState2[1];

  var handleItemClick = react_1.useCallback(function (id, draftActiveChip) {
    var active = draftActiveChip.active;
    var nextActive = !active;
    var nextState = {};

    if (multiple) {
      nextState = Object.assign(Object.assign({}, activeState), _defineProperty({}, id, nextActive));
    } else {
      var keyList = Object.keys(activeState);
      nextState = keyList.reduce(function (acc, key) {
        return Object.assign(Object.assign({}, acc), _defineProperty({}, key, false));
      }, {});
      nextState[id] = nextActive;
    }

    setActiveState(nextState);

    if (onChange) {
      onChange(Object.assign(Object.assign({}, draftActiveChip), {
        active: nextActive
      }));
    }

    if (onActiveListChange) {
      onActiveListChange(nextState);
    }
  }, [activeState, multiple]);
  react_1.useEffect(function () {
    if (activeChipId) {
      var activeChipIds = getValidChipIdList(activeChipId, multiple);
      var nextState = items.reduce(function (acc, cur) {
        return Object.assign(Object.assign({}, acc), _defineProperty({}, cur.id, activeChipIds.includes(cur.id)));
      }, {});
      setActiveState(nextState);
    }
  }, [activeChipId, multiple, items]);
  return jsx_runtime_1.jsx("div", Object.assign({
    ref: ref,
    className: className,
    css: styles.container(direction)
  }, {
    children: items.map(function (_ref2, index) {
      var content = _ref2.content,
          icon = _ref2.icon,
          activeIcon = _ref2.activeIcon,
          id = _ref2.id;
      return jsx_runtime_1.jsx(ChipItem_1.default, Object.assign({
        id: id,
        className: "mrt-chip-item",
        index: index,
        shape: shape,
        active: activeState[id],
        icon: icon,
        activeIcon: activeIcon,
        onClick: handleItemClick
      }, {
        children: content
      }), id);
    })
  }), void 0);
});
exports.default = ChipV2;